// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

// Only forward valid Button props, not 'env'
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'env',
})(({ theme, env }: { theme: any; env?: string }) => ({
  padding: '0.375rem 0.75rem',
  borderRadius: '2px',
  color: COLORS.WHITE,
  backgroundColor: env && env === 'dev' ? COLORS.TEST_ENV : theme.mainColor,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.mainColorMedium,
    color: COLORS.WHITE,
  },
  '&.MuiButton-sizeSmall': {
    padding: '0.25rem 0.5rem',
  },
  '&.MuiButton-sizeLarge': {
    padding: '0.5rem 1rem',
  },
  '&.Mui-disabled': {
    boxShadow: 'none',
    backgroundColor: COLORS.DISABLED_BUTTON_BG,
    color: COLORS.GRAY_SHADE_40,
  },
  '&.Mui-focusVisible': {
    outline: `thick double ${theme.mainColor}`,
  },
}));

const PrimaryButton = (props: ButtonProps & { env?: string }) => {
  return <StyledButton {...props} />;
};

export default PrimaryButton;
